(() => {
  if (window.GearonimoFooterCategoryLinksReady) return;
  window.GearonimoFooterCategoryLinksReady = true;

  const footerSelector = '.keep-browsing--footer';
  const cardSelector = `${footerSelector} .browse-category-card[href]`;
  const dragLimit = 10;
  let activePointer = null;
  let lastPointer = null;

  const closestCard = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest(cardSelector);
  };

  document.addEventListener('pointerdown', (event) => {
    const card = closestCard(event.target);
    if (!card) return;

    activePointer = {
      id: event.pointerId,
      card,
      x: event.clientX,
      y: event.clientY,
      moved: false
    };
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (!activePointer || event.pointerId !== activePointer.id) return;

    const deltaX = event.clientX - activePointer.x;
    const deltaY = event.clientY - activePointer.y;
    if (Math.hypot(deltaX, deltaY) > dragLimit) activePointer.moved = true;
  }, true);

  document.addEventListener('pointerup', (event) => {
    if (!activePointer || event.pointerId !== activePointer.id) return;

    lastPointer = {
      card: activePointer.card,
      moved: activePointer.moved,
      time: Date.now()
    };
    activePointer = null;

    window.setTimeout(() => {
      if (lastPointer && Date.now() - lastPointer.time > 500) lastPointer = null;
    }, 550);
  }, true);

  document.addEventListener('pointercancel', (event) => {
    if (activePointer && event.pointerId === activePointer.id) activePointer = null;
  }, true);

  document.addEventListener('click', (event) => {
    const card = closestCard(event.target);
    if (!card) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    const wasDrag = lastPointer
      && lastPointer.card === card
      && lastPointer.moved
      && Date.now() - lastPointer.time < 600;
    lastPointer = null;
    if (wasDrag) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(card.href);
  }, true);
})();
